import { render, staticRenderFns } from "./creatInvoice.vue?vue&type=template&id=038a59a7&scoped=true"
import script from "./creatInvoice.vue?vue&type=script&lang=js"
export * from "./creatInvoice.vue?vue&type=script&lang=js"
import style0 from "./creatInvoice.vue?vue&type=style&index=0&id=038a59a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a59a7",
  null
  
)

export default component.exports